import axios, {AxiosInstance} from "axios";

export default abstract class Api {
  protected _axiosInstance: AxiosInstance;

  constructor() {
    this._axiosInstance = axios.create({
      baseURL: `${REACT_APP_BACK4FRONT_ENDPOINT}`,
    });

    this._axiosInstance.interceptors.request.use(
      async (config) => {
        config.headers = config.headers || {};
        return config;
      },
      (error) => error
    );

    this._axiosInstance.interceptors.response.use(
      (response) => {
        if ([200, 201, 204, 404].indexOf(response.status) === -1) {
          return Promise.reject(response);
        }
        return response;
      },
      (error) => error
    );
  }
}
